module.exports = __webpack_public_path__ + "static/media/trashCan.103e7e05.svg";